import { BulkCancel, TaskControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */
interface Params {
  bulkCancel: BulkCancel;
  xTENANTID?: string;
}

export const useTaskCancel = () =>
  useMutationWithLoading(async (params: Params) =>
    new TaskControllerApi(getConfigObject()).cancelTasks(
      params?.bulkCancel,
      params.xTENANTID
    )
  );
